import React from 'react'

function Background() {
    return null
}

export default Background